import * as apiUtil from '../apiUtils';
import * as apiCommon from '../apiCommon';
import { EXCHANGE_RATE } from '../../constants/constant_doc_types';
import moment from 'moment';

export function saveExchangeRate(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  let exchangeRateData = {
    doc_type: EXCHANGE_RATE,
    effective_date: apiUtil.toUtcDate(data.effective_date),
    currency_from_id: data.currency_from_id,
    currency_to_id: data.currency_to_id,
    rate: apiUtil.toDecimal(data.rate),
  };

  return apiCommon.saveDoc(app, {
    source: data,
    doc: exchangeRateData,
    user,
  });
}

export function deleteExchangeRate(app, data) {
  return apiCommon.deleteDoc(app, {
    id: data.id,
    docType: EXCHANGE_RATE,
  });
}

export function fetchExchangeRateById(app, params) {
  const { id } = params;
  const docType = EXCHANGE_RATE;
  return apiCommon.getDoc(app, { id, docType });
}

export async function getExchangeRate(app, params) {
  const { currencyFromId, currencyToId, date } = params;
  const effectiveDate = moment(date).set("hour", 0).set("minute", 0).set("second", 0).format();
  const result = await apiCommon.queryDocs(
    app,
    EXCHANGE_RATE,
    {
      where: {
        currency_from_id: currencyFromId,
        currency_to_id: currencyToId,
        effective_date: {
          $gte: effectiveDate,
        },
      },
    },  
    'post',
  );
  return result.total ? result.data[0] : null;
}
